export const SUBSCRIPTIONS = 'subscriptions';
export const AUTH_SUBSCRIPTIONS = 'auth/subscriptions';
export const SUBSCRIPTIONS_API_VERSION = 'api-version=1.0';
